import { render, staticRenderFns } from "./Bucket.vue?vue&type=template&id=2ac01e36&scoped=true&"
import script from "./Bucket.vue?vue&type=script&lang=js&"
export * from "./Bucket.vue?vue&type=script&lang=js&"
import style0 from "./Bucket.scss?vue&type=style&index=0&id=2ac01e36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac01e36",
  null
  
)

export default component.exports